document.addEventListener('DOMContentLoaded', () => {
    const bar = document.querySelector(
        '[data-announcement-bar]'
    );

    if (!bar) return;

    const containers =
        bar.querySelectorAll('.top_scroll');

    if (!containers.length) return;

    containers.forEach((container) => {
        const track = container.querySelector(
            '.announcement-track'
        );

        if (!track) return;

        let index = 0;
        let interval = null;
        let resizeTimer = null;
        let slideRaf = null;

        const SLIDE_DURATION = 600;

        const SLIDE_DELAY =
            parseInt(
                bar.dataset.slideDelay,
                10
            ) || 5000;

        let items = Array.from(track.children).filter(
            (item) =>
                window.getComputedStyle(item)
                    .display !== 'none'
        );

        let totalItems = items.length;

        if (totalItems <= 1) return;

        const firstItem = items[0];

        // Single layout read
        let itemHeight =
            firstItem.offsetHeight || 55;

        // Single clone creation
        const clone =
            firstItem.cloneNode(true);

        clone.dataset.announcementClone =
            'true';

        track.appendChild(clone);

        const stopSlider = () => {
            if (!interval) return;

            clearInterval(interval);
            interval = null;

            if (slideRaf) {
                cancelAnimationFrame(slideRaf);
                slideRaf = null;
            }
        };

        const slide = () => {
            index++;

            if (slideRaf) {
                cancelAnimationFrame(slideRaf);
            }

            slideRaf = requestAnimationFrame(() => {
                slideRaf = null;

                track.style.transition =
                    `transform ${SLIDE_DURATION}ms ease-in-out`;

                track.style.transform =
                    `translate3d(0,-${index * itemHeight}px,0)`;
            });

            if (index >= totalItems) {
                window.setTimeout(() => {
                    requestAnimationFrame(() => {
                        track.style.transition =
                            'none';

                        track.style.transform =
                            'translate3d(0,0,0)';

                        index = 0;
                    });
                }, SLIDE_DURATION);
            }
        };

        const startSlider = () => {
            if (interval) return;

            interval = window.setInterval(
                slide,
                SLIDE_DELAY
            );
        };

        // Single observer
        const observer =
            new IntersectionObserver(
                ([entry]) => {
                    if (entry.isIntersecting) {
                        startSlider();
                    } else {
                        stopSlider();
                    }
                },
                {
                    threshold: 0.2,
                }
            );

        observer.observe(container);

        container.addEventListener(
            'mouseenter',
            stopSlider
        );

        container.addEventListener(
            'mouseleave',
            startSlider
        );

        window.addEventListener(
            'resize',
            () => {
                clearTimeout(resizeTimer);

                resizeTimer = window.setTimeout(
                    () => {
                        itemHeight =
                            firstItem.offsetHeight ||
                            55;
                    },
                    150
                );
            },
            { passive: true }
        );
    });
});